<template>
  <svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 24 24">
    <path
      d="M19.6,21l-6.3-6.3c-.5.4-1.1.7-1.7.9-.6.2-1.3.4-2.1.4-1.8,0-3.4-.6-4.6-1.9-1.3-1.3-1.9-2.8-1.9-4.6s.6-3.4,1.9-4.6c1.3-1.3,2.8-1.9,4.6-1.9s3.4.6,4.6,1.9c1.3,1.3,1.9,2.8,1.9,4.6s-.1,1.4-.4,2.1c-.2.7-.5,1.2-.9,1.7l6.3,6.3-1.4,1.4ZM9.5,14c1.2,0,2.3-.4,3.2-1.3s1.3-1.9,1.3-3.2-.4-2.3-1.3-3.2-1.9-1.3-3.2-1.3-2.3.4-3.2,1.3-1.3,1.9-1.3,3.2.4,2.3,1.3,3.2,1.9,1.3,3.2,1.3Z"
    />
  </svg>
</template>
